import { QuestionGroup } from './question-group.model';
import { QuestionType } from './question-type.model';

export class Question {
  help?: string;
  id?: number;
  isEnabled?: boolean;
  isMandatory?: boolean;
  position?: number;
  question?: string;
  questionGroup?: QuestionGroup | string;
  type?: QuestionType | string;


  constructor(values= {}) {
    Object.assign(this, values);
  }
}
